var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var PenIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 52,
    glyphHeight: 52,
    glyphOffsetY: -3,
    glyphOffsetX: 2
  }), React.createElement("path", {
    d: "M50.8235 22.4349L29.1569 0.768188C28.3097 -0.0789792 26.9404 -0.0789792 26.0932 0.768188L21.7599 5.10152C20.9127 5.94869 20.9127 7.31802 21.7599 8.16519L43.4265 29.8319C43.849 30.2544 44.4037 30.4667 44.9584 30.4667C45.513 30.4667 46.0677 30.2544 46.4902 29.8319L50.8235 25.4985C51.6707 24.6514 51.6707 23.282 50.8235 22.4349Z"
  }), React.createElement("path", {
    d: "M20.241 12.7754L7.36451 17.6027C6.63001 17.8779 6.10351 18.5279 5.98434 19.3036L0.218842 48.3087L13.1083 35.4192C12.7032 34.5721 12.4583 33.6339 12.4583 32.6329C12.4583 29.0427 15.3682 26.1329 18.9583 26.1329C22.5485 26.1329 25.4583 29.0427 25.4583 32.6329C25.4583 36.2231 22.5485 39.1329 18.9583 39.1329C17.9573 39.1329 17.0192 38.8881 16.172 38.4829L3.28251 51.3724L32.2877 45.6069C33.0612 45.4877 33.7112 44.9591 33.9863 44.2267L38.8158 31.3481L20.241 12.7754Z"
  }));
};
export var PenIconGlyph = function (props) {
  return React.createElement(PenIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};